<template>
	<span>
		<support-form-details></support-form-details>
		<page-footer></page-footer>
	</span>
</template>
<script>
	import SupportFormDetails from "@/components/SupportFormDetails";
	import PageFooter from "@/components/PageFooter";
	export default {
		name: "purchaseform",
		components: {
			SupportFormDetails,
			PageFooter,
		},
	};
</script>